import { Redirect } from 'expo-router';
import { useAtomValue } from 'jotai/index';
import * as React from 'react';

import GoalDetails from '../../../goals/components/details/GoalDetails';
import { selectedGoalAtom } from '../../../goals/state/GoalAtoms';

export default function Details() {
    const goal = useAtomValue(selectedGoalAtom);

    if (goal == null) {
        return <Redirect href="/roadmap/tasks" />;
    }

    return <GoalDetails goal={goal} />;
}
